import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'repeat'
})
export class RepeatPipe implements PipeTransform {
    transform(value: number): any {
        return new Array(value).fill(null).map((_, i) => i);
    }
}
